"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChevronRightSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7.85366656,5.14812687 L11.7010886,9.00019644 L7.84883812,12.8545114 C7.65549651,13.047853 7.34217977,13.047853 7.14893188,12.8546051 C6.95549906,12.6611723 6.95512999,12.3476697 7.14810684,12.153782 L10.287268,8.99980356 L7.14821587,5.8468489 C6.95542094,5.6532001 6.95611314,5.33992556 7.14976194,5.14713064 C7.15006407,5.14682984 7.15036659,5.14652943 7.1506695,5.14622941 C7.34555703,4.95320179 7.65982386,4.95405003 7.85366656,5.14812687 Z" })));
};
ChevronRightSmall.displayName = 'ChevronRightSmall';
exports.default = ChevronRightSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronRightSmall.js.map